import { SyntheticEvent, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Box, Tab } from '@mui/material';
import '../maintenance/Maintenance';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import Logistics from './accounts/Logistics';
import Trucks from './truck-zone/Trucks';
import LoginRedirect from '../../../../common/components/loginredirect/LoginRedirect';

const DispatchManagement = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState<string>('0');
  const tabLabels = [
    // { label: 'Summary', path: 'summary', component: <Summary /> },
    { label: 'Truck Zone', path: 'truck-zone', component: <Trucks /> },
    // { label: 'Loads', path: 'loads', component: <Loads /> },
    { label: 'Accounts', path: 'logistics', component: <Logistics /> }
    // { label: 'Dispatch', path: 'dispatchs', component: <Dispatch /> }
    // { label: 'Inspection', path: 'inspection', component: <Inspection /> },
    // { label: 'Maintenance', path: 'maintenance', component: <Maintenance /> }
  ];

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  useEffect(() => {
    const defaultPath = 'truck-zone';
    const pathUrl = tabLabels.findIndex(tab => location.pathname.includes(tab.path));
    if (location.pathname === '/dispatch-management') {
      navigate(`/dispatch-management/${defaultPath}`);
    } else {
      setValue(pathUrl.toString());
    }
  }, [location.pathname, navigate, tabLabels]);

  return (
    <Box className='management-container'>
      <TabContext value={value}>
        <Box className='tab-context animate__animated animate__slideInRight animate__fast'>
          <Box className='tab-list '>
            {/* Loop function for the tab names: */}
            <TabList
              aria-label='lab API tabs example'
              onChange={handleChange}
              variant='scrollable'
              allowScrollButtonsMobile
            >
              {tabLabels.map((tab, index) => (
                <Tab
                  key={index}
                  className='tab'
                  label={tab.label}
                  value={index.toString()}
                  component={Link}
                  to={`/dispatch-management/${tab.path}`}
                />
              ))}
            </TabList>
          </Box>
        </Box>

        <Box sx={{ height: `calc(100vh - 100px)`, overflowX: 'hidden' }}>
          {/* Loop function for the tab name components: */}
          {tabLabels.map((tab, index) => (
            <TabPanel
              key={index}
              value={index.toString()}
              className='tab-panel animate__animated animate__slideInRight '
            >
              {tab.component}
            </TabPanel>
          ))}
        </Box>

        <LoginRedirect />
      </TabContext>
    </Box>
  );
};

export default DispatchManagement;
